/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PagedList } from '../models/paged-list';
import { ProjectDto } from '../models/project-dto';
import { projectsFindAll } from '../fn/projects/projects-find-all';
import { ProjectsFindAll$Params } from '../fn/projects/projects-find-all';

@Injectable({ providedIn: 'root' })
export class ProjectsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsFindAll()` */
  static readonly ProjectsFindAllPath = '/projects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsFindAll$Response(params?: ProjectsFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedList & {
'items'?: Array<ProjectDto>;
}>> {
    const obs = projectsFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsFindAll(params?: ProjectsFindAll$Params, context?: HttpContext): Observable<PagedList & {
'items'?: Array<ProjectDto>;
}> {
    const resp = this.projectsFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedList & {
'items'?: Array<ProjectDto>;
}>): PagedList & {
'items'?: Array<ProjectDto>;
} => r.body)
    );
  }

}
